
















import { mixins } from 'vue-class-component';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import gql from 'graphql-tag';
import { Box, BoxStyle, BoxStyleDimension } from '../../../common/box';
import { Project } from '../../../common/project';

import * as BOX_STYLES_QUERY from 'src/graphql/BoxStyles.graphql';
import * as BOX_DIMENSIONS_FRAGMENT_QUERY from 'src/graphql/BoxDimensionsFragment.graphql';
import * as BOX_STYLE_FRAGMENT_QUERY from 'src/graphql/BoxStyleFragment.graphql';

@Component({
  apollo: {
    box_styles_for_group: {
      query: BOX_STYLES_QUERY,
      fetchPolicy: 'cache-and-network',
    },
  }
})
export default class BoxList extends Vue {
  @Prop() editable : boolean;

  get project() {
    return this.$store.state.currentProject
  }

  box_styles_for_group = [];

  get box(): Box {
    return this.project && this.project.box;
  }

  selected = null;

  @Watch('box')
  onBoxChanged() {
    this.selected = this.box_styles_for_group.find( dbStyle => dbStyle.id == this.box.style.id );
  }

  @Watch('box_styles_for_group')
  onBoxStylesLoaded() {
    if (this.box.style != null)
      this.selected = this.box_styles_for_group.find( dbStyle => dbStyle.id == this.box.style.id );
  }

  @Watch('selected')
  onBoxStyleChanged() {
    if (this.selected != null && this.box.style.id != this.selected.id) {

      let dimensions = [];
      for (let i = 0; i < this.selected.dimensions.length; ++i) {
        var lower_limit = this.selected.dimensions[i].lower_limit;
        var upper_limit = this.selected.dimensions[i].upper_limit;
        // limits are in mm, but dimensions are in meter
        dimensions.push( (lower_limit + upper_limit)/2000 );
      }

      this.$apollo.mutate({
        mutation: gql`mutation ($projectId: Int!, $boxStyleId: Int!, $dimensions: [Float]!) {
            updateBox(projectId: $projectId, boxStyleId: $boxStyleId, dimensions: $dimensions) {
              ...BoxDimensions
              ...BoxStyle
            }
          }
          ${BOX_DIMENSIONS_FRAGMENT_QUERY}
          ${BOX_STYLE_FRAGMENT_QUERY}
        `,
        variables: {
          projectId: this.$store.state.currentProject.id,
          boxStyleId: this.selected.id,
          dimensions: dimensions
        },
        update: (store, { data: { updateBox } }) => {
          let box = JSON.parse(JSON.stringify(this.box));
          box.dimensions = updateBox.dimensions;
          box.style = updateBox.style;

          store.writeFragment({
            id: `Box:${this.box.id}`,
            fragment: gql`fragment BoxStyleDimension on Box {
                ...BoxDimensions
                ...BoxStyle
              }
              ${BOX_DIMENSIONS_FRAGMENT_QUERY}
              ${BOX_STYLE_FRAGMENT_QUERY}
            `,
            fragmentName: 'BoxStyleDimension',
            data: box
          });
        },
        optimisticResponse: {
          __typename: 'Mutation',
          updateBox: {
            __typename: 'Box',
            dimensions: dimensions,
            style: this.selected
          },
        },
      });
    }
  }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BoxList.vue